const CAROUSEL_ITEMS = [
  {
    id: 1,
    title: '暑期档必看大片合集',
    subtitle: '2026最燃暑期电影季',
    desc: '汇聚本季最受期待的国内外大片，从好莱坞视效巨制到国产口碑黑马，一部不落全收录。高清画质，多线路切换，畅享影院级暑期观影体验。',
    tag: '热门推荐',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20summer%20blockbuster%20movie%20collage%20with%20warm%20golden%20sunset%20gradient%20background%2C%20film%20strip%20elements%2C%20dramatic%20lighting%2C%20theater%20spotlight%20effect%2C%20epic%20cinematic%20atmosphere%2C%20no%20text%2C%20luxurious%20dark%20and%20gold%20tones&width=600&height=400&seq=carousel-01-summer&orientation=landscape',
  },
  {
    id: 2,
    title: '8090经典港片回顾',
    subtitle: '那些年我们追过的港片',
    desc: '重温周星驰喜剧、成龙动作、王家卫文艺，8090年代港片黄金时代的经典之作全部高清修复。每一帧都是青春记忆，每部片都是港片巅峰。',
    tag: '经典怀旧',
    image: 'https://readdy.ai/api/search-image?query=Nostalgic%20Hong%20Kong%20cinema%20retro%20aesthetic%20with%20neon%20city%20lights%20and%20vintage%20film%20texture%2C%20warm%20amber%20and%20teal%20color%20palette%2C%20classic%20movie%20homage%2C%20cinematic%20composition%2C%20no%20text%2C%20dreamy%20nostalgic%20atmosphere&width=600&height=400&seq=carousel-02-hk&orientation=landscape',
  },
  {
    id: 3,
    title: '豆瓣高分冷门佳片',
    subtitle: '错过就可惜的小众神作',
    desc: '精选豆瓣8.5分以上的冷门佳作，涵盖悬疑、剧情、纪录片等多种类型。这些不被大众熟知的神作，每一部都值得反复品味，影迷进阶必看片单。',
    tag: '影迷进阶',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20independent%20film%20aesthetic%20with%20soft%20moody%20lighting%20and%20film%20reel%20elements%2C%20deep%20indigo%20and%20warm%20gold%20contrast%2C%20thoughtful%20cinematic%20composition%2C%20elegant%20minimal%20design%2C%20no%20text%2C%20atmospheric%20textures&width=600&height=400&seq=carousel-03-indie&orientation=landscape',
  },
  {
    id: 4,
    title: '好莱坞视效巨制精选',
    subtitle: '视觉盛宴一网打尽',
    desc: '从漫威宇宙到DC英雄，从科幻史诗到灾难巨制，集结好莱坞最顶级的视觉特效大片。4K超高清画质，多声道原声，每一部都是视听双重享受。',
    tag: '视觉盛宴',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Hollywood%20blockbuster%20visual%20effects%20aesthetic%20with%20cinematic%20blue%20and%20gold%20cosmic%20lighting%2C%20sci-fi%20and%20superhero%20elements%20blended%20abstractly%2C%20dramatic%20composition%2C%20no%20text%2C%20powerful%20atmospheric%20design&width=600&height=400&seq=carousel-04-hollywood&orientation=landscape',
  },
  {
    id: 5,
    title: '国产现实主义力作',
    subtitle: '看见真实的中国故事',
    desc: '聚焦国产现实主义佳作，从社会议题到人文关怀，这些有温度、有深度的电影正在重新定义中国电影。真实的力量最动人，每一部都值得静心观看。',
    tag: '口碑佳作',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20realist%20cinema%20artistic%20aesthetic%20with%20warm%20earthy%20tones%20and%20textured%20film%20grain%2C%20humanistic%20documentary%20style%20lighting%2C%20intimate%20storytelling%20atmosphere%2C%20no%20text%2C%20subtle%20and%20powerful%20composition&width=600&height=400&seq=carousel-05-chinese&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100/60">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            精心策划的观影专题，覆盖热门大片、经典重温与小众佳作，总有一款适合你的口味
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {CAROUSEL_ITEMS.slice(0, 3).map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/30 hover:border-primary-500/20 transition-all duration-300 group cursor-pointer"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/10 to-transparent"></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full text-xs font-medium bg-accent-500 text-foreground-950">
                  {item.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-base font-heading font-bold text-foreground-950 mb-1.5">{item.title}</h3>
                <p className="text-xs text-primary-500 font-medium mb-2.5">{item.subtitle}</p>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 mt-5 md:mt-6">
          {CAROUSEL_ITEMS.slice(3, 5).map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/30 hover:border-primary-500/20 transition-all duration-300 group cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="relative h-44 sm:h-auto sm:w-52 flex-shrink-0 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-transparent to-background-50/50 sm:bg-gradient-to-t sm:from-background-50/80 sm:via-background-50/10 sm:to-transparent"></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full text-xs font-medium bg-accent-500 text-foreground-950">
                  {item.tag}
                </span>
              </div>
              <div className="p-5 flex-1 flex flex-col justify-center">
                <h3 className="text-base font-heading font-bold text-foreground-950 mb-1.5">{item.title}</h3>
                <p className="text-xs text-primary-500 font-medium mb-2.5">{item.subtitle}</p>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}